<template>
  <div class="formBox-contents-row__item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormBoxItemRow',
};
</script>

<style lang="scss" scoped>

.formBox-contents-row__item {
  margin-bottom: 0.25rem;
  margin-right: 0.25rem;
  max-width: 100%;

  @include pad-width() {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  span {
    align-self: center;
  }

  span:has(span) {
    align-self: unset;
  }
}

</style>
